module.exports = __webpack_public_path__ + "assets/HKNova-ExtraLight.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-ExtraLight.ttf
// module id = 115
// module chunks = 0